import {useDebugValue} from 'react';

import {noop} from '../../../utils/noop';

import {useEvents} from './useEvents';

const defaultDetailsModalEvents = {
    onSettingsChange: noop,
    onClose: noop,
    onOpen: noop,
    onSecondaryActionClick: noop
};

function useDetailsModalEvents(props) {
    const {
        detailsModalEvents: propsDetailsModalEvents
    } = props;

    const {
        events: detailsModalEvents
    } = useEvents(defaultDetailsModalEvents, propsDetailsModalEvents);

    const result = {
        detailsModalEvents
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModalEvents};
